import { useRef } from "react";
import { Singleton, truncateToTwoDecimals } from "helper/tools";
import * as SVGImages from "../../../svg";
import styles from "./Gauge.module.css";

function Gauge({
  percentage = 0,
  title = "",
  desc = "",
  perCompareVenta = 0,
  showPercentaje = true,
  descIsCurrency = true,
  loading = false,
  multiLine = false,
  multiLineValues = [],
}) {
  const numberFormatter = useRef(null);

  function ImageForPerc() {
    const percSVGStyle =
      perCompareVenta < 1
        ? styles.gauge_svg_color_down
        : styles.gauge_svg_color_up;

    let statusImage = (
      <SVGImages.ArrowUP
        className={`${styles.gauge_svg_color_size} ${percSVGStyle}`}
      />
    );
    if (perCompareVenta < 1 && perCompareVenta > 0) {
      statusImage = (
        <SVGImages.ArrowDOWN
          className={`${styles.gauge_svg_color_size} ${percSVGStyle}`}
        />
      );
    } else if (perCompareVenta === 0 || perCompareVenta === 1 || loading) {
      statusImage = null;
    }

    return <>{statusImage}</>;
  }

  function multiLineRender() {
    return (
      <>
        <div
          className="card placeholder-glow"
          style={{ width: "200px", height: "80px" }}
        >
          <div className="card-body1 text-center">
            <p className={`fs-7 `} style={{ marginBottom: "0px" }}>
              {title}
            </p>

            {loading && (
              <div
                className="card-text fs-4 fw-bold placeholder"
                style={{ display: "flex", margin: "10px" }}
              ></div>
            )}
            {!loading && (
              <ul
                className="list-group list-group-flush"
                style={{ paddingRight: "10px" }}
              >
                {multiLineValues.map((value, index) => {
                  return (
                    <li
                      className="list-group-item d-flex justify-content-between align-items-start"
                      style={{
                        padding: "0px",
                        border: "none",
                      }}
                    >
                      <div className="ms-2 me-auto">
                        <div className="fw-bold" style={{ fontSize: "12px" }}>
                          {value.name}
                        </div>
                      </div>
                      <span className="" style={{ fontSize: "11px" }}>
                        {value.value}
                      </span>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        </div>
      </>
    );
  }

  function formatNumber(number) {
    if (descIsCurrency) {
      return Singleton.getInstance().format(number);
    }
    if (numberFormatter.current == null) {
      const locale = "es-MX";
      //  const currencyValue = "MXN";
      numberFormatter.current = new Intl.NumberFormat(locale);
    }

    return numberFormatter.current.format(number);
  }

  const fixed = (perCompareVenta * 100).toFixed(2);
  const perc = truncateToTwoDecimals(fixed);
  const textStyle =
    perc > 0 && perc < 100
      ? styles.gauge_text_down
      : perc > 100
        ? styles.gauge_text_up
        : "";
  const descFormatted = formatNumber(desc);

  let percFinal = perc;
  if (percFinal >= 100) {
    percFinal -= 100;
  } else {
    percFinal = 100 - percFinal;
  }
  if (loading) percFinal = 0;

  if (multiLine) {
    return multiLineRender();
  }

  return (
    <>
      <div
        className="card placeholder-glow"
        style={{ width: "200px", height: "80px" }}
      >
        <div className="card-body1 text-center">
          <p className={`fs-7 `} style={{ marginBottom: "0px" }}>
            {title}
          </p>
          <p
            className={`card-text fs-4 fw-bold ${loading ? "placeholder" : ""}`}
            style={{ marginBottom: "0px" }}
          >
            {descFormatted}
          </p>
          <p className={`card-text fs-8 `}>
            {showPercentaje && (
              <>
                <ImageForPerc />
                <span className={textStyle}>{percFinal} %</span>
              </>
            )}
          </p>
        </div>
      </div>
    </>
  );
}

export default Gauge;
